export default __webpack_public_path__ + "static/media/employee.f9e28433.png";